// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"342c3875a3ab4e82621b","873":"329ea9b0dc5db7c142b0"}[chunkId] + ".js";
};